
// $(".header-mobile-menu").on("click",function(){
// 	$(".header-nav").toggleClass("active");
// 	$(this).toggleClass("active");
// 	$(".global-overlay").toggleClass("open");
// });

// $(".header-mobile-search").on("click",function(event){
// 	event.preventDefault();
// 	$(".header-mobile-search-con").toggleClass("active");
// 	$(this).toggleClass("active");
// 	$(".global-overlay").toggleClass("open");

// });

$.fn.hasAttr = function(name) {  
	return this.attr(name) !== undefined;
};


$(".header-nav-right-each").on("click",function(){
	// $(".header-bottom-con").addClass("search-open");
	// $(".header-mobile-search-con").addClass("active");

	// setTimeout(function(){
	// 	$("#header-search").focus();
	// },100);
	if ($(this).find(".header-search-icon").length > 0) {
		if ($(this).hasClass("active")){
			$(this).removeClass("active");
			$("#header-search").removeClass("active");
		} else {
			$("#header-search").addClass("active");
			$(this).addClass("active");
			
		}
	}
	
});

$(".header-mobile-close-icon").on("click",function(){
	$(this).parent().parent().removeClass("active");
	$("#header-search").blur();
	$(".header-search-icon").removeClass("active");
});

$(".products-listing-each:not(.contact-listing-each)").hover(

	function(e){
		if (ww >= 960){
			$(this).addClass('hovered');
			$(this).parent().find('.products-listing-each:not(.hovered)').css('opacity', '0.5');
		}
	},
	function(e){
		if (ww >= 960){
			$(this).parent().find('.products-listing-each:not(.hovered)').css('opacity', '1');
			$(this).removeClass('hovered');
			
		}
	}

	);


// $(".header-nav-shortcut").on("click",function(){
// 	$(this).next().toggleClass("open");
// 	//$(".header-user-nav-con").toggleClass("open");
// });